export const getFinancialInstitutionColumns = (t) => ({
  assets: [
    {
      field: 'accountType',
      headerName: t('Account type'),
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'account',
      headerName: t('Account Number'),
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'remarks',
      headerName: t('Remarks'),
      flex: 2,
      minWidth: 220,
    },
  ],
  liabilities: [
    {
      field: 'liabilityType',
      headerName: t('Liability type'),
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'account',
      headerName: t('Account Number'),
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'remarks',
      headerName: t('Remarks'),
      flex: 2,
      minWidth: 220,
    },
  ],
  creditCards: [
    {
      field: 'name',
      headerName: t('Credit Card / Issuer Name'),
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'number',
      headerName: t('Number'),
      flex: 1,
      minWidth: 180,
    },
    {
      field: 'remarks',
      headerName: t('Remarks'),
      flex: 2,
      minWidth: 220,
    },
  ],
});

export const getOtherFinancialLiabilitiesColumns = (t) => [
  {
    field: 'liabilityProviderName',
    headerName: t('Liability Provider Name'),
    flex: 1.4,
    minWidth: 220,
  },
  {
    field: 'liabilityType',
    headerName: t('Liability Type'),
    flex: 1,
    minWidth: 180,
  },
  {
    field: 'number',
    headerName: t('Account Number'),
    flex: 1,
    minWidth: 180,
  },
  {
    field: 'remarks',
    headerName: t('Remarks'),
    flex: 1.4,
    minWidth: 220,
  },
];

export const getOtherCreditCardsColumns = (t) => [
  {
    field: 'name',
    headerName: t('Credit Card / Issuer Name'),
    flex: 1.4,
    minWidth: 220,
  },
  {
    field: 'number',
    headerName: t('Account Number'),
    flex: 1,
    minWidth: 180,
  },
  {
    field: 'remarks',
    headerName: t('Remarks'),
    flex: 1.4,
    minWidth: 220,
  },
];
